import { useCallback, useEffect, useState } from "react";
import { SmartSoftButton, SmartTable, SmartTableNewInterface } from "soft_digi";
import { ACCESSKEY_URLS } from "../../api/AccessKeyUrls";
import { useSiteContext } from "../../contexts/SiteProvider";
import { LOADING } from "../../services/MsgService";
import { showYesOrNoAlert } from "../../services/notifyService";
import { get, post } from "../../services/smartApiService";
import AccessKeysForm from "./AccessKeysForm";


const AccessKeysTable = () => {
  const [data, setData] = useState<any[]>([]);
  const { setLoading, openModal } = useSiteContext();
  const loadTableData = useCallback((purpose = "") => {
    setData([])
    // return setData(sampleData)
    setLoading(true, purpose && purpose + "ing...");
    const subscription = get(ACCESSKEY_URLS.GET_ALL).subscribe((response) => {
      setData(response.data.data);
      purpose
        ? setTimeout(() => setLoading(false), 800)
        : setLoading(false);
    });
    return () => subscription.unsubscribe();
  }, []);

  useEffect(() => {
    loadTableData();
  }, []);



  const deleteItem = (obj: any) => {
    showYesOrNoAlert(`Do you want to Delete "${obj["server_name"]}"?`, (result: string) => {
      if (result == "yes") {
        send_delete_request(obj);
      }
    }, "question");
  };

  const regenerate = (obj: any) => {
    showYesOrNoAlert(`Do you want to Regenerate Access Key of "${obj["server_name"]}"?`, (result: string) => {
      if (result == "yes") {
        send_regenerated_request(obj);
      }
    }, "question");
  };

  const send_regenerated_request = (obj: any) => {   
    const subscription = post(ACCESSKEY_URLS.REGENERATE, { id: obj["id"] },{loadingMsg:LOADING.GENERATE}).subscribe((response) => {
       loadTableData();
    }
    );
    return () => subscription.unsubscribe();
  }

  const send_delete_request = (obj: any) => {   
    const subscription = post(ACCESSKEY_URLS.DELETE, { id: obj["id"] },{loadingMsg:LOADING.DELETE}).subscribe((response) => {
     // setLoading(false);
     // showNotification("success", `${obj["project_name"]} Project Deleted Successfully`);
      loadTableData();
    }
    );
    return () => subscription.unsubscribe();
  }


 


  const actionButtons = [
    {
      leftIcon: "fa-pencil",
      type: "icon",
      classList: ["has-text-link"],
      onClick: (row: any) => regenerate(row)
    },
    {
      leftIcon: "fa-trash",
      type: "icon",
      classList: ["has-text-danger"],
      onClick: (row: any) => deleteItem(row)
    },
  ]

  const columns: SmartTableNewInterface.SmartTableNewColumnConfig[] = [
    { title: "S.NO", index: "s_no", type: "sno", width: "5" },
    { title: "SERVER", index: "server_name", },
    { title: "DOMAIN/IP ADDRESS", index: "server_url" },
    { title: "ACCESS KEY", index: "access_key",  },
    { title: "", index: "action", type: "action", width: "5", buttons: actionButtons },
  ];

  const openForm = (data_in:any) => {
    let modalObject = {
      title: "New Access Key",
      content: <AccessKeysForm dataIn={data_in} loadTableData={loadTableData} />,
      bodyClose: false,
      modalClass: "smart-modal-70"
    }
    openModal(modalObject)
  }


  const tableTop: SmartTableNewInterface.SmartTableNewTopProps[] = [
    {
      type: "CUSTOM",
      widthClass: "is-4",
      custom: <p className="has-text-link is-size-4">Access Keys</p>,

    },
    {
      type: "BUTTONS",
      widthClass: "is-2",
      align: "CENTER",
      buttons: [
        {
          type: "REFRESH",
          action: () => loadTableData()
        },
      ],
    },
    {
      type: "SEARCH",
      widthClass: "is-4",
      align: "RIGHT",
    },

    {
      type: "CUSTOM",
      widthClass: "is-2",
      align: "RIGHT",
      custom:
        <div className="buttons mx-3">
          <SmartSoftButton
            label="Add Key"
            onClick={openForm}
            leftIcon="fa-plus"
            classList={["smart-third-button"]}
          />
        </div>
    },
  ]




  return (
    <div>
      <div className="shadow my-4">
        <SmartTable
          tableTop={tableTop}
          columns={columns}
          data={data}
          tableProps={{
            className: "table is-hoverable is-striped smart-pdf-table",
            isResponsive: true,
            searchIndexes: ["project_name", "roles"],
            searchPlaceHolder: "Search",
          }}
        />
      </div>
    </div>
  );
};

export default AccessKeysTable;
